module.exports = __webpack_public_path__ + "media/images/features/draft/eyecatch-mypage-0c38eb67bf02d939ce3ad890babd7581.png";